import { AfterViewInit, Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';

import { AuthService } from '@auth/auth.service';
import { WebcomponentsService } from '@core/service/webcomponents.service';

import { ProductType, SCREEN_TYPE_CONSTANTS } from '@core/model/enums';
import { COOKIE_ENUMERATION } from '@home/login/configs';

import { environment } from '@environments/environment';
import { ROUTES_CONSTANTS } from '@shared/configs';

export enum PRODUCTS_INITIALS_ENUMERATION {
  RAPIFLEXYA = 'RFYA',
}

@Component({
  selector: 'app-application-rejection',
  templateUrl: './application-rejection.component.html',
  styleUrls: ['./application-rejection.component.scss'],
})
export class ApplicationRejectionComponent implements AfterViewInit {
  @ViewChild('applicationRejectionRef', { static: false })
  public applicationRejectionRef!: ElementRef;

  private readonly webComponentService: WebcomponentsService = this.injector.get(WebcomponentsService);
  private readonly router: Router = this.injector.get(Router);
  private readonly cookieService: CookieService = this.injector.get(CookieService);
  public readonly authService: AuthService = this.injector.get(AuthService);
  private readonly route: ActivatedRoute = this.injector.get(ActivatedRoute);
  private productType: string;
  private screenType: string;

  constructor(private readonly injector: Injector) {}

  public ngAfterViewInit(): void {
    const applicationRejection = this.applicationRejectionRef.nativeElement;
    this.route.queryParamMap.subscribe((params) => {
      this.productType = params.get('productType') || ProductType.RP;
      this.screenType = params.get('screenType') || SCREEN_TYPE_CONSTANTS.REJECTED;
    });
    this.webComponentService.isLoaded$.subscribe({
      next: (loaded) => {
        if (loaded) {
          applicationRejection.ngElementStrategy?.componentRef?.instance?.build({
            backActionFn: () => {
              this.router.navigate(['/home']);
            },
            nextActionFn: (event: { productType: ProductType }) => {
              if (event.productType === ProductType.RP && this.screenType !== SCREEN_TYPE_CONSTANTS.CONGRATULATIONS) {
                this.cookieService.set(COOKIE_ENUMERATION.CRFRAP, this.authService.token, 1, '/', environment.domain);
                window.location.href = environment.myCreditsRapiflex;
              } else if (event.productType === ProductType.RFYA) {
                this.router.navigate([ROUTES_CONSTANTS.REFERRALS]);
              } else if (
                event.productType === ProductType.RETRP ||
                this.screenType === SCREEN_TYPE_CONSTANTS.CONGRATULATIONS
              ) {
                this.router.navigate([ROUTES_CONSTANTS.HOME]);
              } else if (event.productType === ProductType.RETRF) {
                this.router.navigate([ROUTES_CONSTANTS.HOME]);
              }
            },
            productType: this.productType,
            screenType: this.screenType,
          });
        }
      },
    });
  }
}
